document.addEventListener('DOMContentLoaded', function () {
  try {
    const container = document.querySelector('.shipping-progress-container');
    if (!container) return;

    let updateTimeout = null;
    let lastCheckedTotal = null;

    function updateShippingProgressBar(cartData) {
      try {
        const progressFill = container.querySelector('.shipping-progress-fill');
        const progressText = container.querySelector('.shipping-progress-text');

        if (!progressFill || !progressText) return;

        // Read threshold and currency dynamically each time
        const threshold = parseFloat(container.getAttribute('data-threshold'));
        const currencySymbol = container.getAttribute('data-currency-symbol');

        // Hide progress bar if cart is empty
        if (cartData.item_count === 0) {
          container.style.display = 'none';
          return;
        }

        // Show progress bar if cart has items
        container.style.display = '';

        const cartTotal = cartData.total_price / 100;

        // Only update if total changed
        if (lastCheckedTotal === cartTotal) return;
        lastCheckedTotal = cartTotal;

        const percentage = Math.min((cartTotal / threshold) * 100, 100);
        progressFill.style.width = percentage + '%';

        if (cartTotal >= threshold) {
          progressText.innerHTML = 'Free shipping applied <span class="shipping-checkmark"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none"><path d="M8.89718 0.599998L3.19294 6.30425L0.600098 3.71141" stroke="#4D1B26" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
        } else {
          const remaining = (threshold - cartTotal).toFixed(2);
          progressText.innerHTML = `Spend <span class="currency-symbol">${currencySymbol}</span><span class="remaining-amount">${remaining}</span> and get free shipping`;
        }
      } catch (e) {
        console.error('Error updating progress bar UI:', e);
      }
    }

    function fetchAndUpdate() {
      try {
        fetch('/cart.json')
          .then(response => response.json())
          .then(cartData => updateShippingProgressBar(cartData))
          .catch(error => console.error('Error fetching cart data:', error));
      } catch (e) {
        console.error('Error in fetchAndUpdate:', e);
      }
    }

    function debouncedUpdate() {
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(fetchAndUpdate, 250);
    }

    // Initial update on page load
    setTimeout(() => fetchAndUpdate(), 50);

    // Watch cart drawer for changes
    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        debouncedUpdate();
      });

      // Watch the entire cart drawer for any changes
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }

    // Hook into window.qf_cart if available
    if (window.qf_cart) {
      // Intercept Fetch requests to cart.json
      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const url = args[0];
        if (typeof url === 'string' && url.includes('cart')) {
          const result = originalFetch.apply(this, args);
          result
            .then(response => response.clone().json().then(data => {
              if (data.total_price !== undefined) {
                updateShippingProgressBar(data);
              }
            }))
            .catch(() => {});
          return result;
        }
        return originalFetch.apply(this, args);
      };
    }

  } catch (e) {
    console.error('Error initializing shipping progress bar:', e);
  }
});